import { useEffect, useState } from 'react';
import { fetchLeaderboard } from '../api/client';
import { LeaderboardEntry } from '../types';

interface Props {
  onBack: () => void;
}

type Period = 'alltime' | 'daily' | 'weekly';

export default function Leaderboard({ onBack }: Props) {
  const [period, setPeriod] = useState<Period>('alltime');
  const [entries, setEntries] = useState<LeaderboardEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    fetchLeaderboard(period)
      .then((res) => {
        if (!cancelled) setEntries(res.entries);
      })
      .catch((e) => {
        if (!cancelled) setError(e.message || 'Could not load leaderboard.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [period]);

  return (
    <div className="screen">
      <div className="arcade-subtitle">Global Leaderboard</div>
      <div className="panel" style={{ width: 520 }}>
        <div className="tab-row">
          {(['alltime', 'daily', 'weekly'] as Period[]).map((p) => (
            <button
              key={p}
              className={`tab-btn ${period === p ? 'active' : ''}`}
              onClick={() => setPeriod(p)}
            >
              {p === 'alltime' ? 'All-Time' : p === 'daily' ? 'Daily' : 'Weekly'}
            </button>
          ))}
        </div>

        {loading && <div className="loading-text">Loading rankings...</div>}
        {error && <div className="error-text">{error}</div>}

        {!loading && !error && (
          <table className="leaderboard-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Player</th>
                <th>Score</th>
                <th>Acc.</th>
                <th>Lvl</th>
              </tr>
            </thead>
            <tbody>
              {entries.length === 0 && (
                <tr>
                  <td colSpan={5} style={{ textAlign: 'center', padding: 20 }}>
                    No scores yet. Be the first!
                  </td>
                </tr>
              )}
              {entries.map((e) => (
                <tr key={e.username} className={e.rank <= 3 ? `rank-${e.rank}` : ''}>
                  <td>{e.rank}</td>
                  <td>{e.username}</td>
                  <td>{e.score.toLocaleString()}</td>
                  <td>{e.accuracy}%</td>
                  <td>{e.level}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <div style={{ marginTop: 18, display: 'flex', justifyContent: 'center' }}>
          <button className="arcade-btn secondary" onClick={onBack}>
            Back
          </button>
        </div>
      </div>
    </div>
  );
}
